import React,{ Component } from 'react'
import './index.css'
import emptyImg from './images/img_wugongzuo.png'
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import {BsyUtils} from "../../utils/Utils";


class AlertList extends Component{
    state = {
        menu:[
            {
                type: 'all',
                text: React.language('selectAll'),
                checked: false,
                disabled: false,
                onChange: (event) =>{
                    event.stopPropagation()
                    const {menu, workflows, entry, contact} = this.state
                    menu[0].checked = !menu[0].checked
                    this.setState({menu:menu.map((val)=>{
                            val.checked = menu[0].checked
                            return val
                        }),workflows:workflows.map((val)=>{
                            val.checked = menu[0].checked
                            val.child.map((val1)=>{
                                val1.checked = menu[0].checked
                                return val1
                            })
                            return val
                        }),entry:entry.map((val)=>{
                            val.checked = menu[0].checked
                            val.child.map((val1)=>{
                                val1.checked = menu[0].checked
                                return val1
                            })
                            return val
                        }),contact:contact.map((val)=>{
                            val.checked = menu[0].checked
                            return val
                        })})
                }
            },{
                type: 'todo',
                text: React.language('todo.data'),
                select: true,
                checked: false,
                disabled: true,
                onChange: (event) =>{
                    // console.log(event.target.checked)
                }
            },{
                type: 'flow',
                text: React.language('flow.user'),
                select: false,
                checked: false,
                disabled: false,
                onChange: (event) =>{
                    event.stopPropagation()
                    let {menu} = this.state
                    menu[2].checked = !menu[2].checked
                    this.setState({menu,workflows:this.state.workflows.map((val)=>{
                            val.checked = menu[2].checked
                            val.child.map((val1)=>{
                                val1.checked = menu[2].checked
                                return val1
                            })
                            return val
                        })})
                    menu[0].checked = menu[2].checked && menu[3].checked && menu[4].checked && menu[5].checked;
                }
            },{
                type: 'flow_creator',
                text: React.language('flow.flowCreator'),
                select: false,
                checked: false,
                disabled: true,
                onChange: (event) =>{
                    // console.log(event.target.checked)
                }
            },{
                type: 'form',
                text: React.language('form.dash.config'),
                select: false,
                checked: false,
                disabled: false,
                onChange: (event) =>{
                    event.stopPropagation()
                    let {menu} = this.state
                    menu[4].checked = !menu[4].checked
                    this.setState({menu,entry:this.state.entry.map((val)=>{
                            val.checked = menu[4].checked
                            val.child.map((val1)=>{
                                val1.checked = menu[4].checked
                                return val1
                            })
                            return val
                        })})
                    menu[0].checked = menu[2].checked && menu[3].checked && menu[4].checked && menu[5].checked;
                }
            },{
                type: 'role',
                text: React.language('role'),
                checked: false,
                disabled: false,
                onChange: (event) =>{
                    event.stopPropagation()
                    let {menu} = this.state
                    menu[5].checked = !menu[5].checked
                    this.setState({menu,contact:this.state.contact.map((val)=>{
                            val.checked = menu[5].checked
                            return val
                        })})
                    menu[0].checked = menu[2].checked && menu[3].checked && menu[4].checked && menu[5].checked;
                }
            },{
                type: 'creator',
                text: React.language('field.creator'),
                select: false,
                checked: false,
                disabled: true,
                onChange: (event) =>{
                    // console.log(event.target.checked)
                }
            }
        ],
        todoShow:true,
        flowShow:false,
        formShow:false,
        roleShow:false,
        creatorShow: false,
        flowCreatorShow: false,
        todoLoadShow:true,
        flowLoadShow:true,
        formLoadShow:true,
        roleLoadShow:true,
        creatorLoadShow:true,
        flowCreatorLoadShow:true,
        load: false,
        showLoad: false,
        finishLoad: false,
        errorLoad: false,
        toUser: null,
        TodoList : [],
        CreatorList : [],
        FlowCreatorList : [],
        FlowsList : [],
        EntryList : [],
        ContactList : [],
        todoList:{},
        creatorList: {},
        flowCreatorList: {},
        workflows:[],
        workflowsList:{},
        entry:[],
        entryList:{},
        contact:[],
        contactList:[],
        apps:[],
        creatorApps:[],
        flowCreatorApps:[],
    }
    init = () =>{
        React.axios('/dashboard/apps').then(res =>{
            if(res.data.apps.length <= 0){
                tipAlert({
                    type:"warning",
                    msg:React.language('handover.work.empty')
                })
                this.closeAlter()
                return
            }
            const newData = res.data.apps.map((val, key) =>{
                return {
                    expanded: key === 0,
                    checked: false,
                    name: val.name,
                    opened: key === 0,
                    todoList: [],
                    creatorList: [],
                    flowCreatorList: [],
                    id: val._id
                }
            })
            const creatorApps = res.data.apps.map((val, key) =>{
                return {
                    expanded: key === 0,
                    checked: false,
                    name: val.name,
                    opened: key === 0,
                    todoList: [],
                    creatorList: [],
                    flowCreatorList: [],
                    id: val._id
                }
            })
            const flowCreatorApps = res.data.apps.map((val, key) =>{
                return {
                    expanded: key === 0,
                    checked: false,
                    name: val.name,
                    opened: key === 0,
                    todoList: [],
                    creatorList: [],
                    flowCreatorList: [],
                    id: val._id
                }
            })
            this.setState({apps:newData, creatorApps, flowCreatorApps},() =>{
                let {apps, workflows, entry, contact} = this.state
                const {userInfo} = this.props
                React.axios('/corp/handover/get_todo_forms',{
                    appId: apps[0].id,
                    memberId: userInfo._id
                }).then(res =>{
                    apps[0].todoList = res.data.forms.map(val =>{
                        return {
                            appId:val.appId,
                            entryId:val.entryId,
                            count:null,
                            name:val.name,
                            checked:false
                        }
                    });
                    apps[0].opened = true;
                    apps[0].expanded = true;
                    this.setState({apps})
                }).catch(res =>{

                })
                React.axios('/corp/handover/get_workflow_config',{
                    memberId: userInfo._id
                }).then(res =>{
                    workflows = res.data.workflows.map(val =>{
                        return {
                            appId:val.appId,
                            child:val.child,
                            name:val.name,
                            expanded:true,
                            checked:false
                        }
                    });
                    this.setState({workflows})
                }).catch(res =>{

                })
                React.axios('/corp/handover/get_entry_config',{
                    memberId: userInfo._id
                }).then(res =>{
                    entry = res.data.entries.map(val =>{
                        let child = []
                        for(let i = 0; i < val.child.length; i++){
                            for(let l =0; l < val.child[i].handovers.length; l++){
                                let handoverChild = {...val.child[i]}
                                handoverChild.handover = val.child[i].handovers[l]
                                child = [...child,handoverChild]
                            }
                        }
                        return {
                            appId:val.appId,
                            child:child,
                            name:val.name,
                            expanded:true,
                            checked:false
                        }
                    });
                    this.setState({entry})
                }).catch(res =>{

                })
                React.axios('/corp/handover/get_contact_config',{
                    memberId: userInfo._id
                }).then(res =>{
                    contact = res.data.roles.map(val =>{
                        return {
                            role_id:val.role_id,
                            name:val.name,
                            checked:false
                        }
                    });
                    this.setState({contact},()=>{
                        let {creatorApps} = this.state
                        const {userInfo} = this.props
                        React.axios('/corp/handover/get_creator_data_forms',{
                            appId: creatorApps[0].id,
                            memberId: userInfo._id
                        }).then(res =>{
                            creatorApps[0].creatorList = res.data.forms.map(val =>{
                                return {
                                    appId:val.appId,
                                    entryId:val.entryId,
                                    count:null,
                                    name:val.name,
                                    checked:false
                                }
                            });
                            creatorApps[0].opened = true;
                            creatorApps[0].expanded = true;
                            this.setState({creatorApps},()=>{
                                let {flowCreatorApps} = this.state
                                const {userInfo} = this.props
                                React.axios('/corp/handover/get_flow_creator_forms',{
                                    appId: flowCreatorApps[0].id,
                                    memberId: userInfo._id
                                }).then(res =>{
                                    flowCreatorApps[0].flowCreatorList = res.data.forms.map(val =>{
                                        return {
                                            appId:val.appId,
                                            entryId:val.entryId,
                                            count:null,
                                            name:val.name,
                                            checked:false
                                        }
                                    });
                                    flowCreatorApps[0].opened = true;
                                    flowCreatorApps[0].expanded = true;
                                    this.setState({flowCreatorApps})
                                }).catch(res =>{
                
                                })
                            })
                        }).catch(res =>{
        
                        })
                    })
                }).catch(res =>{

                })
            })
        }).catch(res =>{

        })
    }
    constructor(props) {
        super(props);
        this.init()
    }

    closeAlter = () =>{
        document.getElementsByClassName("BsyAlertHandover")[0].classList.remove('fadein')
        this.props.onClose && this.props.onClose()
        setTimeout(() =>{
            document.getElementsByClassName("BsyAlertHandover")[0].remove()
        },218)
    }

    handoverClick = () =>{
        const {todoList, workflows, entry, contact, creatorList, flowCreatorList} = this.state;
        let {CreatorList, FlowCreatorList, TodoList, FlowsList, EntryList, ContactList} = this.state
        const {userInfo} = this.props;
        const _this = this;
        let checkedFlag = true;
        TodoList = [];
        FlowsList = [];
        EntryList = [];
        ContactList = [];
        CreatorList = [];
        FlowCreatorList = [];
        for(let p in todoList){
            checkedFlag = false
            todoList[p].showLoad = false;
            todoList[p].loadFinish = false;
            TodoList.push(todoList[p])
        }

        for(let p in creatorList){
            checkedFlag = false
            creatorList[p].showLoad = false;
            creatorList[p].loadFinish = false;
            CreatorList.push(creatorList[p])
        }
        for(let p in flowCreatorList){
            checkedFlag = false
            flowCreatorList[p].showLoad = false;
            flowCreatorList[p].loadFinish = false;
            FlowCreatorList.push(flowCreatorList[p])
        }
        workflows.map(val =>{
            return val.child.map(val1 =>{
                if(val1.checked){
                    val1.showLoad = false;
                    val1.loadFinish = false;
                    FlowsList.push(val1)
                    checkedFlag = false
                }
                return false
            })
        })

        entry.map(val =>{
            return val.child.map(val1 =>{
                if(val1.checked){
                    val1.showLoad = false;
                    val1.loadFinish = false;
                    val1.type = val1.handover
                    EntryList.push(val1)
                    checkedFlag = false
                }
                return false
            })
        })

        contact.map(val =>{
            if(val.checked){
                val.showLoad = false;
                val.loadFinish = false;
                ContactList.push(val)
                checkedFlag = false
            }
            return false
        })
        if(checkedFlag){
            tipAlert({
                type:"warning",
                msg:React.language('handover.empty.tip1')
            })
            return
        }
        this.setState({TodoList,FlowsList,EntryList,ContactList})
        const d = new window.FX.ConfirmDialog({
            title: React.language("member.select.list"),
            height: 576,
            width: 710,
            contentWidget: {
                rowSize: [440],
                colSize: [680],
                padding: 15,
                items: [[{
                    widgetName: "memberSelect",
                    type: "memberselectpane",

                    editable: !0,  
                    radioItem: !0,
                    radioEnable: !0,
                    roleEnable: !1,
                    roleChildEnable: !1,
                    outsiderMemberEnable: !1,
                    outsiderGroupEnable: !1,
                    departmentEnable: !1,
                    hasTeamManageBtn: !1,
                    hasDock: false,
                }]]
            },
            onOk: function() {
                const t = d.getWidgetByName("memberSelect").getValue();
                const s = d.getWidgetByName("memberSelect").getAllJsonValue();
                // console.log(s)
                if(t.length<=0){
                    tipAlert({
                        type:"warning",
                        msg:React.language('handover.error.tip1')
                    })
                    return
                }

                if(userInfo._id === t[0]){
                    tipAlert({
                        type:"warning",
                        msg:React.language('handover.error.tip')
                    })
                    return
                }
                _this.setState({toUser:t,load:true,showLoad:true})
                React.axios('/corp/handover/start_transfer',{
                    from:userInfo._id,
                    to:t[0]._id ? t[0]._id : t[0]
                }).then(res =>{
                    let axiosList = []
                    TodoList.map((value, key) => {
                        axiosList.push({
                            url:'/corp/handover/flow_data_transfer',
                            data:{
                                "from": userInfo._id,
                                "to": t[0]._id ? t[0]._id : t[0],
                                "task_id": res.data.task_id,
                                "appId": value.appId,
                                "entryId": value.entryId
                            },
                            before: () =>{
                                TodoList[key].showLoad = true;
                                _this.setState({TodoList})
                            },
                            error: (res) =>{
                                TodoList[key].showLoad = false;
                                TodoList[key].loadError = true;
                                _this.setState({TodoList})
                            },
                            success: (res) =>{
                                TodoList[key].data = res.data;
                                TodoList[key].showLoad = false;
                                TodoList[key].loadFinish = true;
                                _this.setState({TodoList})
                            }
                        })
                        return false
                    })
                    CreatorList.map((value, key) => {
                        axiosList.push({
                            url:'/corp/handover/creator_data_transfer',
                            data:{
                                "from": userInfo._id,
                                "to": t[0]._id ? t[0]._id : t[0],
                                "task_id": res.data.task_id,
                                "appId": value.appId,
                                "entryId": value.entryId
                            },
                            before: () =>{
                                CreatorList[key].showLoad = true;
                                _this.setState({CreatorList})
                            },
                            error: (res) =>{
                                CreatorList[key].showLoad = false;
                                CreatorList[key].loadError = true;
                                _this.setState({CreatorList})
                            },
                            success: (res) =>{
                                CreatorList[key].data = res.data;
                                CreatorList[key].showLoad = false;
                                CreatorList[key].loadFinish = true;
                                _this.setState({CreatorList})
                            }
                        })
                        return false
                    })
                    FlowCreatorList.map((value, key) => {
                        axiosList.push({
                            url:'/corp/handover/flow_creator_data_transfer',
                            data:{
                                "from": userInfo._id,
                                "to": t[0]._id ? t[0]._id : t[0],
                                "task_id": res.data.task_id,
                                "appId": value.appId,
                                "entryId": value.entryId
                            },
                            before: () =>{
                                FlowCreatorList[key].showLoad = true;
                                _this.setState({FlowCreatorList})
                            },
                            error: (res) =>{
                                FlowCreatorList[key].showLoad = false;
                                FlowCreatorList[key].loadError = true;
                                _this.setState({FlowCreatorList})
                            },
                            success: (res) =>{
                                FlowCreatorList[key].data = res.data;
                                FlowCreatorList[key].showLoad = false;
                                FlowCreatorList[key].loadFinish = true;
                                _this.setState({FlowCreatorList})
                            }
                        })
                        return false
                    })
                    FlowsList.map((value, key) => {
                        axiosList.push({
                            url:'/corp/handover/workflow_config_transfer',
                            data:{
                                "from": userInfo._id,
                                "to": t[0]._id ? t[0]._id : t[0],
                                "task_id": res.data.task_id,
                                "appId": value.appId,
                                "entryId": value.entryId
                            },
                            before: () =>{
                                FlowsList[key].showLoad = true;
                                _this.setState({FlowsList})
                            },
                            error: (res) =>{
                                FlowsList[key].showLoad = false;
                                FlowsList[key].loadError = true;
                                _this.setState({FlowsList})
                            },
                            success: (res) =>{
                                FlowsList[key].showLoad = false;
                                FlowsList[key].loadFinish = true;
                                _this.setState({FlowsList})
                            }
                        })
                        return false
                    })
                    EntryList.map((value, key) => {
                        axiosList.push({
                            url:'/corp/handover/entry_config_transfer',
                            data:{
                                "from": userInfo._id,
                                "to": t[0]._id ? t[0]._id : t[0],
                                "task_id": res.data.task_id,
                                "appId": value.appId,
                                "entryId": value.entryId,
                                "type": value.type,
                            },
                            before: () =>{
                                EntryList[key].showLoad = true;
                                _this.setState({EntryList})
                            },
                            error: (res) =>{
                                EntryList[key].showLoad = false;
                                EntryList[key].loadError = true;
                                _this.setState({EntryList})
                            },
                            success: (res) =>{
                                EntryList[key].showLoad = false;
                                EntryList[key].loadFinish = true;
                                _this.setState({EntryList})
                            }
                        })
                        return false
                    })

                    if(ContactList.length > 0){
                        axiosList.push({
                            url:'/corp/handover/role_transfer',
                            data:{
                                "from": userInfo._id,
                                "to": t[0]._id ? t[0]._id : t[0],
                                "task_id": res.data.task_id,
                                "roles": ContactList.map((val)=>{
                                    return val.role_id
                                }),
                            },
                            before: () =>{
                                ContactList.map(val =>{
                                    val.showLoad = true;
                                    return false
                                })
                                _this.setState({ContactList})
                            },
                            error: (res) =>{
                                ContactList.map(val =>{
                                    val.showLoad = false;
                                    val.loadError = true;
                                    return false
                                })
                                _this.setState({ContactList})
                            },
                            success: (res) =>{
                                ContactList.map(val =>{
                                    val.showLoad = false;
                                    val.loadFinish = true;
                                    return false
                                })
                                _this.setState({ContactList})
                            }
                        })
                    }
                    _this.axiosAll(axiosList, 0, res.data.task_id)
                }).catch(res =>{

                })
                return !1;
            }
        });
        d.show()
    }

    handoverRefresh = () =>{
        let {FlowCreatorList, CreatorList, TodoList, FlowsList, EntryList, ContactList, toUser} = this.state
        const {userInfo} = this.props;
        const _this = this;
        this.errorLoad = false;
        _this.setState({load:true,showLoad:true,finishLoad:false,errorLoad:false})
        React.axios('/corp/handover/start_transfer',{
            from:userInfo._id,
            to:toUser[0]._id ? toUser[0]._id : toUser[0]
        }).then(res =>{
            let axiosList = []
            TodoList.map((value, key) => {
                axiosList.push({
                    url:'/corp/handover/flow_data_transfer',
                    data:{
                        "from": userInfo._id,
                        "to": toUser[0]._id,
                        "task_id": res.data.task_id,
                        "appId": value.appId,
                        "entryId": value.entryId
                    },
                    before: () =>{
                        if(TodoList[key].loadFinish){
                            return true
                        }else{
                            TodoList[key].showLoad = true;
                            _this.setState({TodoList});
                            return false
                        }
                    },
                    error: (res) =>{
                        TodoList[key].showLoad = false;
                        TodoList[key].loadFinish = false;
                        TodoList[key].loadError = true;
                        _this.setState({TodoList})
                    },
                    success: (res) =>{
                        TodoList[key].data = res.data;
                        TodoList[key].showLoad = false;
                        TodoList[key].loadFinish = true;
                        TodoList[key].loadError = false;
                        _this.setState({TodoList})
                    }
                })
                return false
            })
            CreatorList.map((value, key) => {
                axiosList.push({
                    url:'/corp/handover/creator_data_transfer',
                    data:{
                        "from": userInfo._id,
                        "to": toUser[0]._id,
                        "task_id": res.data.task_id,
                        "appId": value.appId,
                        "entryId": value.entryId
                    },
                    before: () =>{
                        if(CreatorList[key].loadFinish){
                            return true
                        }else{
                            CreatorList[key].showLoad = true;
                            _this.setState({CreatorList});
                            return false
                        }
                    },
                    error: (res) =>{
                        CreatorList[key].showLoad = false;
                        CreatorList[key].loadFinish = false;
                        CreatorList[key].loadError = true;
                        _this.setState({CreatorList})
                    },
                    success: (res) =>{
                        CreatorList[key].data = res.data;
                        CreatorList[key].showLoad = false;
                        CreatorList[key].loadFinish = true;
                        CreatorList[key].loadError = false;
                        _this.setState({CreatorList})
                    }
                })
                return false
            })
            FlowCreatorList.map((value, key) => {
                axiosList.push({
                    url:'/corp/handover/flow_creator_data_transfer',
                    data:{
                        "from": userInfo._id,
                        "to": toUser[0]._id,
                        "task_id": res.data.task_id,
                        "appId": value.appId,
                        "entryId": value.entryId
                    },
                    before: () =>{
                        if(FlowCreatorList[key].loadFinish){
                            return true
                        }else{
                            FlowCreatorList[key].showLoad = true;
                            _this.setState({FlowCreatorList});
                            return false
                        }
                    },
                    error: (res) =>{
                        FlowCreatorList[key].showLoad = false;
                        FlowCreatorList[key].loadFinish = false;
                        FlowCreatorList[key].loadError = true;
                        _this.setState({FlowCreatorList})
                    },
                    success: (res) =>{
                        FlowCreatorList[key].data = res.data;
                        FlowCreatorList[key].showLoad = false;
                        FlowCreatorList[key].loadFinish = true;
                        FlowCreatorList[key].loadError = false;
                        _this.setState({FlowCreatorList})
                    }
                })
                return false
            })
            FlowsList.map((value, key) => {
                axiosList.push({
                    url:'/corp/handover/workflow_config_transfer',
                    data:{
                        "from": userInfo._id,
                        "to": toUser[0]._id ? toUser[0]._id : toUser[0],
                        "task_id": res.data.task_id,
                        "appId": value.appId,
                        "entryId": value.entryId
                    },
                    before: () =>{
                        if(FlowsList[key].loadFinish){
                            return true
                        }else{
                            FlowsList[key].showLoad = true;
                            _this.setState({FlowsList});
                            return false
                        }
                    },
                    error: (res) =>{
                        FlowsList[key].showLoad = false;
                        FlowsList[key].loadFinish = false;
                        FlowsList[key].loadError = true;
                        _this.setState({FlowsList})
                    },
                    success: (res) =>{
                        FlowsList[key].showLoad = false;
                        FlowsList[key].loadError = false;
                        FlowsList[key].loadFinish = true;
                        _this.setState({FlowsList})
                    }
                })
                return false
            })
            EntryList.map((value, key) => {
                axiosList.push({
                    url:'/corp/handover/entry_config_transfer',
                    data:{
                        "from": userInfo._id,
                        "to": toUser[0]._id ? toUser[0]._id : toUser[0],
                        "task_id": res.data.task_id,
                        "appId": value.appId,
                        "entryId": value.entryId,
                        "type": value.type,
                    },
                    before: () =>{
                        if(EntryList[key].loadFinish){
                            return true
                        }else{
                            EntryList[key].showLoad = true;
                            _this.setState({EntryList});
                            return false
                        }
                    },
                    error: (res) =>{
                        EntryList[key].showLoad = false;
                        EntryList[key].loadError = true;
                        EntryList[key].loadFinish = false;
                        _this.setState({EntryList})
                    },
                    success: (res) =>{
                        EntryList[key].showLoad = false;
                        EntryList[key].loadError = false;
                        EntryList[key].loadFinish = true;
                        _this.setState({EntryList})
                    }
                })
                return false
            })

            if(ContactList.length > 0){
                axiosList.push({
                    url:'/corp/handover/role_transfer',
                    data:{
                        "from": userInfo._id,
                        "to": toUser[0]._id ? toUser[0]._id : toUser[0],
                        "task_id": res.data.task_id,
                        "roles": ContactList.map((val)=>{
                            return val.role_id
                        }),
                    },
                    before: () =>{
                        if(ContactList.loadFinish){
                            return true
                        }else{
                            ContactList.map(val =>{
                                val.showLoad = true;
                                return false
                            })
                            _this.setState({ContactList})
                            return false
                        }
                    },
                    error: (res) =>{
                        ContactList.map(val =>{
                            val.showLoad = false;
                            val.loadFinish = false;
                            val.loadError = true;
                            return false
                        })
                        _this.setState({ContactList})
                    },
                    success: (res) =>{
                        ContactList.map(val =>{
                            val.showLoad = false;
                            val.loadError = false;
                            val.loadFinish = true;
                            return false
                        })
                        _this.setState({ContactList})
                    }
                })
            }
            _this.axiosAll(axiosList, 0, res.data.task_id)

        }).catch(res =>{

        })
    }

    errorLoad = false;
    axiosAll = (all, key, task_id) =>{
        if(all.length === key){
            React.axios('/corp/handover/complete_transfer',{
                "task_id":task_id
            }).then(res =>{
                if(this.errorLoad){
                    this.setState({finishLoad:false,errorLoad:true,showLoad:false})
                }else{
                    this.setState({errorLoad:false,finishLoad:true,showLoad:false})
                }
            }).catch(res => {
                if(this.errorLoad){
                    this.setState({finishLoad:false,errorLoad:true,showLoad:false})
                }else{
                    this.setState({errorLoad:false,finishLoad:true,showLoad:false})
                }
            })
            return
        }
        // console.log(all[key].before())
        if(all[key].before()){
            setTimeout(()=>{
                this.axiosAll(all,key+1, task_id);
            },60)
            return
        }
        React.axios(all[key].url,all[key].data).then(res => {
            all[key].success(res);
            setTimeout(()=>{
                this.axiosAll(all,key+1, task_id);
            },60)

        }).catch(res => {
            this.errorLoad = true;
            all[key].error(res);
            setTimeout(()=>{
                this.axiosAll(all,key+1, task_id);
            },60)
        })
    }

    todoChange = (key, list, name) =>{
        return (event) =>{
            event.stopPropagation()
            const {menu, todoList, creatorList, flowCreatorList} = this.state
            const {userInfo} = this.props
            list[key].checked = !list[key].checked;
            if(name === "apps"){
                list[key].todoList = list[key].todoList.map(val =>{
                    val.checked = list[key].checked
                    if(val.checked){
                        todoList[val.entryId] = {
                            "from": userInfo._id,
                            "appId": val.appId,
                            "name": val.name,
                            "entryId": val.entryId
                        }
                    }else{
                        delete todoList[val.entryId]
                    }
                    return val
                });
                this.setState({apps:list})
            } else if(name === "creator"){
                list[key].creatorList = list[key].creatorList.map(val =>{
                    val.checked = list[key].checked
                    if(val.checked){
                        creatorList[val.entryId] = {
                            "from": userInfo._id,
                            "appId": val.appId,
                            "name": val.name,
                            "entryId": val.entryId
                        }
                    }else{
                        delete creatorList[val.entryId]
                    }
                    return val
                });
                this.setState({creatorApps:list})
            } else if(name === "flow_creator"){
                list[key].flowCreatorList = list[key].flowCreatorList.map(val =>{
                    val.checked = list[key].checked
                    if(val.checked){
                        flowCreatorList[val.entryId] = {
                            "from": userInfo._id,
                            "appId": val.appId,
                            "name": val.name,
                            "entryId": val.entryId
                        }
                    }else{
                        delete flowCreatorList[val.entryId]
                    }
                    return val
                });
                this.setState({flowCreatorApps:list})
            } else if(name === "workflows" || name === "entry"){
                list[key].child = list[key].child.map(val =>{
                    val.checked = list[key].checked
                    return val
                });
                let listChecked = true;
                for(let i = 0;i<list.length;i++){
                    if(!list[i].checked){
                        listChecked = false
                    }
                }
                if(name === "workflows"){
                    menu[2].checked = listChecked
                    this.setState({workflows:list,menu})
                }else if(name === "entry"){
                    menu[3].checked = listChecked
                    this.setState({entry:list,menu})
                }
            }
            menu[0].checked = menu[2].checked && menu[3].checked && menu[4].checked && menu[5].checked;
        }
    }

    openTodoList = (val, key, list, name) =>{
        return (event) =>{
            event.stopPropagation()
            const {userInfo} = this.props
            if(name === "workflows" || name === "entry"){
                list[key].expanded = !list[key].expanded;
                this.setState({list})
                return
            }
            if(val.opened){
                list[key].expanded = !list[key].expanded;
                this.setState({list})
                return
            }
            React.axios('/corp/handover/get_todo_forms',{
                appId: val.id,
                memberId: userInfo._id
            }).then(res =>{
                list[key].todoList = res.data.forms.map(val =>{
                    return {
                        appId:val.appId,
                        entryId:val.entryId,
                        count:null,
                        name:val.name,
                        checked:false
                    }
                });
                list[key].opened = true;
                list[key].expanded = !list[key].expanded;
                this.setState({apps:list})
            }).catch(res =>{

            })
        }
    }

    openCreatorList = (val, key, list, name) =>{
        return (event) =>{
            event.stopPropagation()
            const {userInfo} = this.props
            if(name === "workflows" || name === "entry"){
                list[key].expanded = !list[key].expanded;
                this.setState({list})
                return
            }
            if(val.opened){
                list[key].expanded = !list[key].expanded;
                this.setState({list})
                return
            }
            React.axios('/corp/handover/get_creator_data_forms',{
                appId: val.id,
                memberId: userInfo._id
            }).then(res =>{
                list[key].creatorList = res.data.forms.map(val =>{
                    return {
                        appId:val.appId,
                        entryId:val.entryId,
                        count:null,
                        name:val.name,
                        checked:false
                    }
                });
                list[key].opened = true;
                list[key].expanded = !list[key].expanded;
                this.setState({creatorApps:list})
            }).catch(res =>{

            })
        }
    }

    openFlowCreatorList = (val, key, list, name) =>{
        return (event) =>{
            event.stopPropagation()
            const {userInfo} = this.props
            if(name === "workflows" || name === "entry"){
                list[key].expanded = !list[key].expanded;
                this.setState({list})
                return
            }
            if(val.opened){
                list[key].expanded = !list[key].expanded;
                this.setState({list})
                return
            }
            React.axios('/corp/handover/get_flow_creator_forms',{
                appId: val.id,
                memberId: userInfo._id
            }).then(res =>{
                list[key].flowCreatorList = res.data.forms.map(val =>{
                    return {
                        appId:val.appId,
                        entryId:val.entryId,
                        count:null,
                        name:val.name,
                        checked:false
                    }
                });
                list[key].opened = true;
                list[key].expanded = !list[key].expanded;
                this.setState({flowCreatorApps:list})
            }).catch(res =>{

            })
        }
    }

    todoItemChange = (val, key, key2, list, name) =>{
        return (event) =>{
            event.stopPropagation()
            const {todoList, menu, creatorList, flowCreatorList} = this.state
            const {userInfo} = this.props
            if(name === "workflows" || name === "entry"){
                list[key].child[key2].checked = !list[key].child[key2].checked;
                let checked = true;
                for(let i = 0; i < list[key].child.length;i++){
                    if(!list[key].child[i].checked){
                        checked = false
                    }
                }
                let listChecked = true;
                list[key].checked = checked
                for(let i = 0;i<list.length;i++){
                    if(!list[i].checked){
                        listChecked = false
                    }
                }
                if(name === "workflows"){
                    menu[2].checked = listChecked
                    this.setState({workflows:list,menu})
                }else if(name === "entry"){
                    menu[3].checked = listChecked
                    this.setState({entry:list,menu})
                }
            }else if(name === "contact"){
                list[key].checked = !list[key].checked;
                let listChecked = true;
                for(let i = 0;i<list.length;i++){
                    if(!list[i].checked){
                        listChecked = false
                    }
                }
                menu[4].checked = listChecked
                this.setState({contact:list,menu})
            }else if(name === "apps"){
                list[key].todoList[key2].checked = !list[key].todoList[key2].checked;
                if(list[key].todoList[key2].checked){
                    todoList[list[key].todoList[key2].entryId] = {
                        "from": userInfo._id,
                        "appId": list[key].todoList[key2].appId,
                        "name": list[key].todoList[key2].name,
                        "entryId": list[key].todoList[key2].entryId
                    }
                }else{
                    delete todoList[list[key].todoList[key2].entryId]
                }
                if(Object.keys(todoList).length === list[key].todoList.length){
                    list[key].checked = true
                }else if(Object.keys(todoList).length < list[key].todoList.length){
                    list[key].checked = false
                }
                this.setState({apps:list},()=>{
                    const {userInfo} = this.props
                    const {apps} = this.state
                    React.axios('/corp/handover/get_todo_count',{
                        appId: val.appId,
                        entryId: val.entryId,
                        memberId: userInfo._id
                    }).then(res =>{
                        apps[key].todoList[key2].count = res.data.count;
                        this.setState({apps})
                    }).catch(res =>{
        
                    })
                })
            }else if(name === "creator"){
                list[key].creatorList[key2].checked = !list[key].creatorList[key2].checked;
                if(list[key].creatorList[key2].checked){
                    creatorList[list[key].creatorList[key2].entryId] = {
                        "from": userInfo._id,
                        "appId": list[key].creatorList[key2].appId,
                        "name": list[key].creatorList[key2].name,
                        "entryId": list[key].creatorList[key2].entryId
                    }
                }else{
                    delete creatorList[list[key].creatorList[key2].entryId]
                }
                if(Object.keys(creatorList).length === list[key].creatorList.length){
                    list[key].checked = true
                }else if(Object.keys(creatorList).length < list[key].creatorList.length){
                    list[key].checked = false
                }
                this.setState({creatorApps:list})
            }else if(name === "flow_creator"){
                list[key].flowCreatorList[key2].checked = !list[key].flowCreatorList[key2].checked;
                if(list[key].flowCreatorList[key2].checked){
                    flowCreatorList[list[key].flowCreatorList[key2].entryId] = {
                        "from": userInfo._id,
                        "appId": list[key].flowCreatorList[key2].appId,
                        "name": list[key].flowCreatorList[key2].name,
                        "entryId": list[key].flowCreatorList[key2].entryId
                    }
                }else{
                    delete flowCreatorList[list[key].flowCreatorList[key2].entryId]
                }
                if(Object.keys(flowCreatorList).length === list[key].flowCreatorList.length){
                    list[key].checked = true
                }else if(Object.keys(flowCreatorList).length < list[key].flowCreatorList.length){
                    list[key].checked = false
                }
                this.setState({flowCreatorApps:list})
            }
            menu[0].checked = menu[2].checked && menu[3].checked && menu[4].checked && menu[5].checked;
        }
    }

    getTodoCount = (val, key, key2) =>{
        return (event) =>{
            event.stopPropagation()
            const {userInfo} = this.props
            const {apps} = this.state
            React.axios('/corp/handover/get_todo_count',{
                appId: val.appId,
                entryId: val.entryId,
                memberId: userInfo._id
            }).then(res =>{
                apps[key].todoList[key2].count = res.data.count;
                this.setState({apps})
            }).catch(res =>{

            })
        }
    }

    switchType = (type,key) =>{
        return (event) =>{
            event.stopPropagation()
            if(type === "all"){
                return
            }
            const {menu} = this.state;

            if(type === "todo"){
                this.setState({
                    todoShow:true,
                    formShow:false,
                    flowShow:false,
                    roleShow:false,
                    creatorShow:false,
                    flowCreatorShow:false,
                    menu:menu.map((val, key1)=>{
                        val.select = key === key1;
                        return val
                    })
                })
            }else if(type === "form"){
                this.setState({
                    todoShow:false,
                    formShow:true,
                    flowShow:false,
                    roleShow:false,
                    creatorShow:false,
                    flowCreatorShow:false,
                    menu:menu.map((val, key1)=>{
                        val.select = key === key1;
                        return val
                    })
                })
            }else if(type === "flow"){
                this.setState({
                    todoShow:false,
                    formShow:false,
                    flowShow:true,
                    roleShow:false,
                    creatorShow:false,
                    flowCreatorShow:false,
                    menu:menu.map((val, key1)=>{
                        val.select = key === key1;
                        return val
                    })
                })
            }else if(type === "role"){
                this.setState({
                    todoShow:false,
                    formShow:false,
                    flowShow:false,
                    roleShow:true,
                    creatorShow:false,
                    flowCreatorShow:false,
                    menu:menu.map((val, key1)=>{
                        val.select = key === key1;
                        return val
                    })
                })
            }else if(type === "creator"){
                this.setState({
                    todoShow:false,
                    formShow:false,
                    flowShow:false,
                    roleShow:false,
                    creatorShow:true,
                    flowCreatorShow:false,
                    menu:menu.map((val, key1)=>{
                        val.select = key === key1;
                        return val
                    })
                })
            }else if(type === "flow_creator"){
                this.setState({
                    todoShow:false,
                    formShow:false,
                    flowShow:false,
                    roleShow:false,
                    creatorShow:false,
                    flowCreatorShow:true,
                    menu:menu.map((val, key1)=>{
                        val.select = key === key1;
                        return val
                    })
                })
            }
        }
    }

    switchLoadItem = (type) =>{
        return () =>{
            const {todoLoadShow, flowLoadShow, formLoadShow, roleLoadShow, creatorLoadShow, flowCeatorLoadShow} = this.state
            if(type === "todo"){
                this.setState({todoLoadShow:!todoLoadShow})
            }else if(type === "flow"){
                this.setState({flowLoadShow:!flowLoadShow})
            }else if(type === "entry"){
                this.setState({formLoadShow:!formLoadShow})
            }else if(type === "contact"){
                this.setState({roleLoadShow:!roleLoadShow})
            }else if(type === "creator"){
                this.setState({creatorLoadShow:!creatorLoadShow})
            }else if(type === "flow_creator"){
                this.setState({flowCeatorLoadShow:!flowCeatorLoadShow})
            }
        }
    }

    handoverFinish = () =>{
        this.errorLoad = false;
        this.setState({
            menu:[
                {
                    type: 'all',
                    text: React.language('selectAll'),
                    checked: false,
                    disabled: false,
                    onChange: (event) =>{
                        event.stopPropagation()
                        const {menu, workflows, entry, contact} = this.state
                        menu[0].checked = !menu[0].checked
                        this.setState({menu:menu.map((val)=>{
                                val.checked = menu[0].checked
                                return val
                            }),workflows:workflows.map((val)=>{
                                val.checked = menu[0].checked
                                val.child.map((val1)=>{
                                    val1.checked = menu[0].checked
                                    return val1
                                })
                                return val
                            }),entry:entry.map((val)=>{
                                val.checked = menu[0].checked
                                val.child.map((val1)=>{
                                    val1.checked = menu[0].checked
                                    return val1
                                })
                                return val
                            }),contact:contact.map((val)=>{
                                val.checked = menu[0].checked
                                return val
                            })})
                    }
                },{
                    type: 'todo',
                    text: React.language('todo.data'),
                    select: true,
                    checked: false,
                    disabled: true,
                    onChange: (event) =>{
                        // console.log(event.target.checked)
                    }
                },{
                    type: 'flow',
                    text: React.language('flow.user'),
                    select: false,
                    checked: false,
                    disabled: false,
                    onChange: (event) =>{
                        event.stopPropagation()
                        let {menu} = this.state
                        menu[2].checked = !menu[2].checked
                        this.setState({menu,workflows:this.state.workflows.map((val)=>{
                                val.checked = menu[2].checked
                                val.child.map((val1)=>{
                                    val1.checked = menu[2].checked
                                    return val1
                                })
                                return val
                            })})
                        menu[0].checked = menu[2].checked && menu[3].checked && menu[4].checked && menu[5].checked;
                    }
                },{
                    type: 'flow_creator',
                    text: React.language('flow.flowCreator'),
                    select: false,
                    checked: false,
                    disabled: true,
                    onChange: (event) =>{
                        event.stopPropagation()
                    }
                },{
                    type: 'form',
                    text: React.language('form.dash.config'),
                    select: false,
                    checked: false,
                    disabled: false,
                    onChange: (event) =>{
                        event.stopPropagation()
                        let {menu} = this.state
                        menu[4].checked = !menu[4].checked
                        this.setState({menu,entry:this.state.entry.map((val)=>{
                                val.checked = menu[4].checked
                                val.child.map((val1)=>{
                                    val1.checked = menu[4].checked
                                    return val1
                                })
                                return val
                            })})
                        menu[0].checked = menu[2].checked && menu[3].checked && menu[4].checked && menu[5].checked;
                    }
                },{
                    type: 'role',
                    text: React.language('role'),
                    checked: false,
                    disabled: false,
                    onChange: (event) =>{
                        event.stopPropagation()
                        let {menu} = this.state
                        menu[5].checked = !menu[5].checked
                        this.setState({menu,contact:this.state.contact.map((val)=>{
                                val.checked = menu[5].checked
                                return val
                            })})
                        menu[0].checked = menu[2].checked && menu[3].checked && menu[4].checked && menu[5].checked;
                    }
                },{
                    type: 'creator',
                    text: React.language('field.creator'),
                    select: false,
                    checked: false,
                    disabled: true,
                    onChange: (event) =>{
                        event.stopPropagation()
                    }
                }
            ],
            todoShow:true,
            flowShow:false,
            formShow:false,
            roleShow:false,
            creatorShow:false,
            flowCreatorShow:false,
            todoLoadShow:true,
            flowLoadShow:true,
            formLoadShow:true,
            roleLoadShow:true,
            creatorLoadShow:true,
            flowCreatorLoadShow:true,
            load: false,
            showLoad: false,
            errorLoad: false,
            finishLoad: false,
            toUser: null,
            TodoList : [],
            FlowsList : [],
            EntryList : [],
            ContactList : [],
            todoList:{},
            creatorList: {},
            flowCreatorList: {},
            workflows:[],
            workflowsList:{},
            entry:[],
            entryList:{},
            contact:[],
            contactList:[],
            apps:[],
            creatorApps:[],
            flowCreatorApps:[],
        })
        this.init()
    }

    openPageWindow = (name, value) =>{
        return () =>{
            if(name === "todo"){
                BsyUtils.redirectTo(`/dashboard/app/${value.appId}/form/${value.entryId}/edit#/data`,'_blank')
            }else if(name === "flow"){
                BsyUtils.redirectTo(`/dashboard/app/${value.appId}/form/${value.entryId}/edit#/flow`,'_blank')
            }else if(name === "creator"){
                BsyUtils.redirectTo(`/team/app/${value.appId}/form/${value.entryId}/datamanage`,'_blank')
            }else if(name === "flow_creator"){
                BsyUtils.redirectTo(`/team/app/${value.appId}/form/${value.entryId}/datamanage`,'_blank')
            }else if(name === "from"){
                if(value.handover === "auth_group"){
                    BsyUtils.redirectTo(`/dashboard/app/${value.appId}/form/${value.entryId}/edit#/`,'_blank')
                }else if(value.handover === "notify"){
                    BsyUtils.redirectTo(`/dashboard/app/${value.appId}/form/${value.entryId}/edit#/set`,'_blank')
                }else if(value.handover === "datahelper"){
                    BsyUtils.redirectTo(`/dashboard/app/${value.appId}/form/${value.entryId}/edit#/`,'_blank')
                }else if(value.handover === "dash_auth"){
                    BsyUtils.redirectTo(`/dashboard/app/${value.appId}/dash/${value.entryId}/edit`,'_blank')
                }
            }
        }
    }
    render() {
        const {title, styleCss, userInfo} = this.props
        const { CreatorList, creatorApps, creatorShow, creatorLoadShow, FlowCreatorList, flowCreatorApps, flowCreatorShow, flowCreatorLoadShow, todoLoadShow, flowLoadShow, formLoadShow, roleLoadShow, menu, flowShow, formShow, roleShow, todoShow, apps, workflows, entry, contact, load, TodoList, FlowsList, EntryList, ContactList, toUser, showLoad, finishLoad, errorLoad} = this.state
        return (
            <div className={"content " + window.mode} style={styleCss}>
                <div className="dialog-header">
                    <span className="title">{title}</span>
                    <i onClick={this.closeAlter} className="icon-close-large" />
                </div>
                <div className="dialog-body">
                    {!load && <div className="handover-operate">
                        <div className="handover-header">
                            <div className="headerTip">
                                <span className="name">{userInfo.nickname}</span>
                                {React.language('handover.name.tip')}
                            </div>
                            <button className="handoverBtn" onClick={this.handoverClick}>
                                {React.language('flow.action.transfer')}
                            </button>
                        </div>
                        <div className="handover-body">
                            <div className="handover-menu">
                                {
                                    menu.map((val, key) => {
                                        return <>
                                            {
                                                val.type === 'todo' && <div key={"titleFlow"} className={"type-check-item title"}>
                                                    <div className="item-text">{React.language('app.category.flow')}</div>
                                                </div>
                                            }
                                            {
                                                val.type === 'form' && <div key={"titleForm"} className={"type-check-item title"}>
                                                    <div className="item-text">{React.language('crm.authority')}</div>
                                                </div>
                                            }
                                            {
                                                val.type === 'creator' && <div key={"titleData"} className={"type-check-item title"}>
                                                    <div className="item-text">{React.language('data')}</div>
                                                </div>
                                            }
                                            <div key={val.type} onClick={this.switchType(val.type, key)}
                                                        className={val.type === "all" ? "type-check-item all" : val.select ? "type-check-item select" : "type-check-item"}>
                                                <div className="r-check" tabIndex="-1">
                                                    <label className={"check-label " + (val.disabled ? "disabled" : "")}>
                                                    <span className="check-icon">
                                                        {
                                                            val.disabled ? <i className="icon-bsy-check2"/> :
                                                                <i className={val.checked ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"}/>
                                                        }
                                                    </span>
                                                        <input disabled={val.disabled} type="checkbox"
                                                            onChange={val.onChange} className="check-origin" value=""/>
                                                    </label>
                                                </div>
                                                <div className="item-text">{val.text}</div>
                                            </div>
                                        </>
                                    })
                                }
                            </div>
                            <div className="handover-cont">
                                {todoShow && <div className="content-wrapper">
                                    <div className="handover-container">
                                        <div className="panel-tip">
                                            {React.language('todo.data.tip')}
                                        </div>
                                        <div className="panel-container">
                                            <div className="panel-list">
                                                {
                                                    apps.map((val, key) => {
                                                        return <div key={val._id} className="panel-item">
                                                            <div className="item-info"
                                                                 onClick={this.openTodoList(val, key, apps, "apps")}>
                                                                <div className="check-wrapper">
                                                                    <label className={"check-label"}>
                                                                        {
                                                                            val.todoList.length > 0 && val.opened &&
                                                                            <span className="check-icon">
                                                                        {
                                                                            <i className={val.checked ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"}/>
                                                                        }
                                                                        </span>
                                                                        }
                                                                        <input type="checkbox"
                                                                               onChange={this.todoChange(key, apps, "apps")}
                                                                               className="check-origin" value=""/>
                                                                    </label>
                                                                </div>
                                                                <div className="app-name">
                                                                    {
                                                                        val.name
                                                                    }
                                                                </div>
                                                                <div className="item-icon">
                                                                    <i className={val.expanded ? "icon-folder-open" : "icon-folder-close"}/>
                                                                </div>
                                                            </div>
                                                            {
                                                                val.expanded && (val.todoList.length > 0 ?
                                                                    <div className="item-form">
                                                                        {
                                                                            val.todoList.map((val, key2) => {
                                                                                return <div
                                                                                    className="handover-form-item"
                                                                                    onClick={this.todoItemChange(val, key, key2, apps, "apps")}>
                                                                                    <div className="check-wrapper">
                                                                                        <label
                                                                                            className={"check-label"}>
                                                                                            <span className="check-icon">
                                                                                                {
                                                                                                    <i className={val.checked ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"}/>
                                                                                                }
                                                                                            </span>
                                                                                            <input type="checkbox"
                                                                                            onChange={this.todoItemChange(val, key, key2, apps, "apps")}
                                                                                                   className="check-origin"
                                                                                                   value=""/>
                                                                                        </label>
                                                                                    </div>
                                                                                    <div className="form-name">
                                                                                        {
                                                                                            val.name
                                                                                        }
                                                                                    </div>
                                                                                    <div className="form-description">
                                                                                        {React.language('todo.data.tip1')}
                                                                                        {
                                                                                            val.count &&
                                                                                            <span
                                                                                                className="todo-count">
                                                                                        {"（" + React.language('todo.dataCount', {count: val.count}) + "）"}
                                                                                    </span>
                                                                                        }
                                                                                    </div>
                                                                                    <div className="detail-btn-wrapper">
                                                                                        <button onClick={this.openPageWindow("todo",val)}>
                                                                                            <i className="icon-bsy-passwordShow"/>
                                                                                            <span>
                                                                                                {React.language('detail')}
                                                                                            </span>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            })
                                                                        }
                                                                    </div> : <div className="form-empty">
                                                                        {React.language('todo.data.empty.tip')}
                                                                    </div>)
                                                            }
                                                        </div>
                                                    })
                                                }
                                                {
                                                    apps.length === 0 && <div className="listEmpty">
                                                        <div className="emptyCont">
                                                            <img src={emptyImg} alt=""/>
                                                            <p>{React.language('handover.empty.tip')}</p>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                                {formShow && <div className="content-wrapper">
                                    <div className="handover-container">
                                        <div className="panel-tip">
                                            {React.language('form.dash.config.tip')}
                                        </div>
                                        <div className="panel-container">
                                            <div className="panel-list">
                                                {
                                                    entry.map((val, key) => {
                                                        return <div key={val.appId} className="panel-item">
                                                            <div className="item-info"
                                                                 onClick={this.openTodoList(val, key, entry, "entry")}>
                                                                <div className="check-wrapper">
                                                                    <label className={"check-label"}>
                                                                        {
                                                                            val.child.length > 0 &&
                                                                            <span className="check-icon">
                                                                        {
                                                                            <i className={val.checked ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"}/>
                                                                        }
                                                                        </span>
                                                                        }
                                                                        <input type="checkbox"
                                                                               onChange={this.todoChange(key, entry, "entry")}
                                                                               className="check-origin" value=""/>
                                                                    </label>
                                                                </div>
                                                                <div className="app-name">
                                                                    {
                                                                        val.name
                                                                    }
                                                                </div>
                                                                <div className="item-icon">
                                                                    <i className={val.expanded ? "icon-folder-open" : "icon-folder-close"}/>
                                                                </div>
                                                            </div>
                                                            {
                                                                val.expanded && (val.child.length > 0 ?
                                                                    <div className="item-form">
                                                                        {
                                                                            val.child.map((val, key2) => {
                                                                                return <div
                                                                                    className="handover-form-item"
                                                                                    onClick={this.todoItemChange(val, key, key2, entry, "entry")}>
                                                                                    <div className="check-wrapper">
                                                                                        <label
                                                                                            className={"check-label"}>
                                                                                        <span className="check-icon">
                                                                                            {
                                                                                                <i className={val.checked ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"}/>
                                                                                            }
                                                                                        </span>
                                                                                            <input type="checkbox"
                                                                                            onChange={this.todoItemChange(val, key, key2, entry, "entry")}
                                                                                                   className="check-origin"
                                                                                                   value=""/>
                                                                                        </label>
                                                                                    </div>
                                                                                    <div className="form-name">
                                                                                        {
                                                                                            val.name
                                                                                        }
                                                                                    </div>
                                                                                    <div className="form-description">
                                                                                        {React.language(val.handover === 'auth_group' ? 'handover.auth.group' : val.handover === 'notify' ? 'handover.notify' : val.handover === 'datahelper' ? 'handover.datahelper' : val.handover === 'dash_auth' ? 'handover.dash.auth' : '')}
                                                                                    </div>
                                                                                    <div className="detail-btn-wrapper">
                                                                                        <button onClick={this.openPageWindow("from",val)}>
                                                                                            <i className="icon-bsy-passwordShow"/>
                                                                                            <span>
                                                                                                {React.language('detail')}
                                                                                            </span>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            })
                                                                        }
                                                                    </div> : <div className="form-empty">
                                                                        {React.language('todo.data.empty.tip')}
                                                                    </div>)
                                                            }
                                                        </div>
                                                    })
                                                }
                                                {
                                                    entry.length === 0 && <div className="listEmpty">
                                                        <div className="emptyCont">
                                                            <img src={emptyImg} alt=""/>
                                                            <p>{React.language('handover.empty.tip')}</p>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                                {creatorShow && <div className="content-wrapper">
                                    <div className="handover-container">
                                        <div className="panel-tip">
                                            {React.language('creator.data.tip')}
                                        </div>
                                        <div className="panel-container">
                                            <div className="panel-list">
                                                {
                                                    creatorApps.map((val, key) => {
                                                        return <div key={val._id} className="panel-item">
                                                            <div className="item-info"
                                                                 onClick={this.openCreatorList(val, key, creatorApps, "creator")}>
                                                                <div className="check-wrapper">
                                                                    <label className={"check-label"}>
                                                                        {
                                                                            val.creatorList.length > 0 && val.opened &&
                                                                            <span className="check-icon">
                                                                        {
                                                                            <i className={val.checked ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"}/>
                                                                        }
                                                                        </span>
                                                                        }
                                                                        <input type="checkbox"
                                                                               onChange={this.todoChange(key, creatorApps, "creator")}
                                                                               className="check-origin" value=""/>
                                                                    </label>
                                                                </div>
                                                                <div className="app-name">
                                                                    {
                                                                        val.name
                                                                    }
                                                                </div>
                                                                <div className="item-icon">
                                                                    <i className={val.expanded ? "icon-folder-open" : "icon-folder-close"}/>
                                                                </div>
                                                            </div>
                                                            {
                                                                val.expanded && (val.creatorList.length > 0 ?
                                                                    <div className="item-form">
                                                                        {
                                                                            val.creatorList.map((val, key2) => {
                                                                                return <div
                                                                                    className="handover-form-item"
                                                                                    onClick={this.todoItemChange(val, key, key2, creatorApps, "creator")}>
                                                                                    <div className="check-wrapper">
                                                                                        <label
                                                                                            className={"check-label"}>
                                                                                            <span className="check-icon">
                                                                                                {
                                                                                                    <i className={val.checked ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"}/>
                                                                                                }
                                                                                            </span>
                                                                                            <input type="checkbox"
                                                                                            onChange={this.todoItemChange(val, key, key2, creatorApps, "creator")}
                                                                                                   className="check-origin"
                                                                                                   value=""/>
                                                                                        </label>
                                                                                    </div>
                                                                                    <div className="form-name">
                                                                                        {
                                                                                            val.name
                                                                                        }
                                                                                    </div>
                                                                                    <div className="detail-btn-wrapper">
                                                                                        <button onClick={this.openPageWindow("creator",val)}>
                                                                                            <i className="icon-bsy-passwordShow"/>
                                                                                            <span>
                                                                                                {React.language('detail')}
                                                                                            </span>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            })
                                                                        }
                                                                    </div> : <div className="form-empty">
                                                                        {React.language('creator.data.empty.tip')}
                                                                    </div>)
                                                            }
                                                        </div>
                                                    })
                                                }
                                                {
                                                    creatorApps.length === 0 && <div className="listEmpty">
                                                        <div className="emptyCont">
                                                            <img src={emptyImg} alt=""/>
                                                            <p>{React.language('handover.empty.tip')}</p>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                                {flowCreatorShow && <div className="content-wrapper">
                                    <div className="handover-container">
                                        <div className="panel-tip">
                                            {React.language('flow.creator.data.tip')}
                                        </div>
                                        <div className="panel-container">
                                            <div className="panel-list">
                                                {
                                                    flowCreatorApps.map((val, key) => {
                                                        return <div key={val._id} className="panel-item">
                                                            <div className="item-info"
                                                                 onClick={this.openFlowCreatorList(val, key, flowCreatorApps, "flow_creator")}>
                                                                <div className="check-wrapper">
                                                                    <label className={"check-label"}>
                                                                        {
                                                                            val.flowCreatorList.length > 0 && val.opened &&
                                                                            <span className="check-icon">
                                                                        {
                                                                            <i className={val.checked ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"}/>
                                                                        }
                                                                        </span>
                                                                        }
                                                                        <input type="checkbox"
                                                                               onChange={this.todoChange(key, flowCreatorApps, "flow_creator")}
                                                                               className="check-origin" value=""/>
                                                                    </label>
                                                                </div>
                                                                <div className="app-name">
                                                                    {
                                                                        val.name
                                                                    }
                                                                </div>
                                                                <div className="item-icon">
                                                                    <i className={val.expanded ? "icon-folder-open" : "icon-folder-close"}/>
                                                                </div>
                                                            </div>
                                                            {
                                                                val.expanded && (val.flowCreatorList.length > 0 ?
                                                                    <div className="item-form">
                                                                        {
                                                                            val.flowCreatorList.map((val, key2) => {
                                                                                return <div
                                                                                    className="handover-form-item"
                                                                                    onClick={this.todoItemChange(val, key, key2, flowCreatorApps, "flow_creator")}>
                                                                                    <div className="check-wrapper">
                                                                                        <label
                                                                                            className={"check-label"}>
                                                                                            <span className="check-icon">
                                                                                                {
                                                                                                    <i className={val.checked ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"}/>
                                                                                                }
                                                                                            </span>
                                                                                            <input type="checkbox"
                                                                                            onChange={this.todoItemChange(val, key, key2, flowCreatorApps, "flow_creator")}
                                                                                                   className="check-origin"
                                                                                                   value=""/>
                                                                                        </label>
                                                                                    </div>
                                                                                    <div className="form-name">
                                                                                        {
                                                                                            val.name
                                                                                        }
                                                                                    </div>
                                                                                    <div className="detail-btn-wrapper">
                                                                                        <button onClick={this.openPageWindow("flow_creator",val)}>
                                                                                            <i className="icon-bsy-passwordShow"/>
                                                                                            <span>
                                                                                                {React.language('detail')}
                                                                                            </span>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            })
                                                                        }
                                                                    </div> : <div className="form-empty">
                                                                        {React.language('flow.creator.data.empty.tip')}
                                                                    </div>)
                                                            }
                                                        </div>
                                                    })
                                                }
                                                {
                                                    flowCreatorApps.length === 0 && <div className="listEmpty">
                                                        <div className="emptyCont">
                                                            <img src={emptyImg} alt=""/>
                                                            <p>{React.language('handover.empty.tip')}</p>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                                {roleShow && <div className="content-wrapper">
                                    <div className="handover-container">
                                        <div className="panel-tip">
                                            {React.language('role.tip')}
                                        </div>
                                        <div className="panel-container">
                                            <div className="panel-list">
                                                {
                                                    contact.length > 0 && <div className="item-form">
                                                        {
                                                            contact.map((val, key) => {
                                                                return <div className="handover-form-item"
                                                                onClick={this.todoItemChange(val, key, "", contact, "contact")}>
                                                                    <div className="check-wrapper">
                                                                        <label className={"check-label"}>
                                                                            <span className="check-icon">
                                                                                {
                                                                                    <i className={val.checked ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"}/>
                                                                                }
                                                                            </span>
                                                                            <input type="checkbox"
                                                                            onChange={this.todoItemChange(val, key, "", contact, "contact")}
                                                                                   className="check-origin"
                                                                                   value=""/>
                                                                        </label>
                                                                    </div>
                                                                    <div className="form-name">
                                                                        {
                                                                            val.name
                                                                        }
                                                                    </div>
                                                                    <div className="detail-btn-wrapper">

                                                                    </div>
                                                                </div>
                                                            })
                                                        }
                                                    </div>
                                                }
                                                {
                                                    contact.length === 0 && <div className="listEmpty">
                                                        <div className="emptyCont">
                                                            <img src={emptyImg} alt=""/>
                                                            <p>{React.language('handover.empty.tip')}</p>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                                {flowShow && <div className="content-wrapper">
                                    <div className="handover-container">
                                        <div className="panel-tip">
                                            {React.language('flow.user.tip')}
                                        </div>
                                        <div className="panel-container">
                                            <div className="panel-list">
                                                {
                                                    workflows.map((val, key) => {
                                                        return <div key={val.appId} className="panel-item">
                                                            <div className="item-info"
                                                                 onClick={this.openTodoList(val, key, workflows, "workflows")}>
                                                                <div className="check-wrapper">
                                                                    <label className={"check-label"}>
                                                                        {
                                                                            val.child.length > 0 &&
                                                                            <span className="check-icon">
                                                                        {
                                                                            <i className={val.checked ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"}/>
                                                                        }
                                                                        </span>
                                                                        }
                                                                        <input type="checkbox"
                                                                               onChange={this.todoChange(key, workflows, "workflows")}
                                                                               className="check-origin" value=""/>
                                                                    </label>
                                                                </div>
                                                                <div className="app-name">
                                                                    {
                                                                        val.name
                                                                    }
                                                                </div>
                                                                <div className="item-icon">
                                                                    <i className={val.expanded ? "icon-folder-open" : "icon-folder-close"}/>
                                                                </div>
                                                            </div>
                                                            {
                                                                val.expanded && (val.child.length > 0 ?
                                                                    <div className="item-form">
                                                                        {
                                                                            val.child.map((val, key2) => {
                                                                                return <div
                                                                                    className="handover-form-item"
                                                                                    onClick={this.todoItemChange(val, key, key2, workflows, "workflows")}>
                                                                                    <div className="check-wrapper">
                                                                                        <label
                                                                                            className={"check-label"}>
                                                                                            <span className="check-icon">
                                                                                                {
                                                                                                    <i className={val.checked ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"}/>
                                                                                                }
                                                                                            </span>
                                                                                            <input type="checkbox"
                                                                                            onChange={this.todoItemChange(val, key, key2, workflows, "workflows")}
                                                                                                   className="check-origin"
                                                                                                   value=""/>
                                                                                        </label>
                                                                                    </div>
                                                                                    <div className="form-name">
                                                                                        {
                                                                                            val.name
                                                                                        }
                                                                                    </div>
                                                                                    <div className="detail-btn-wrapper">
                                                                                        <button onClick={this.openPageWindow("flow",val)}>
                                                                                            <i className="icon-bsy-passwordShow"/>
                                                                                            <span>
                                                                                                {React.language('detail')}
                                                                                            </span>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            })
                                                                        }
                                                                    </div> : <div className="form-empty">
                                                                        {React.language('todo.data.empty.tip')}
                                                                    </div>)
                                                            }
                                                        </div>
                                                    })
                                                }
                                                {
                                                    workflows.length === 0 && <div className="listEmpty">
                                                        <div className="emptyCont">
                                                            <img src={emptyImg} alt=""/>
                                                            <p>{React.language('handover.empty.tip')}</p>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>}
                    {load && <div className="handover-load">
                        <div className="load-header">
                            <div className="headerTip">
                                {showLoad && <div className="spin-body">
                                    <div className="x-spin mask-none">
                                        <div className="spin-content">
                                            <div className="spin-indicator rotate"/>
                                        </div>
                                    </div>
                                </div>}
                                {
                                    finishLoad && <i className="icon-bsy-finish" />
                                }
                                {
                                    errorLoad && <i className="icon-warning" />
                                }
                                {(finishLoad || errorLoad) ? (errorLoad ? React.language('handover.load.forward') : React.language('handover.finish.tip')) : React.language('handover.work.loading',{user:userInfo.nickname,to:toUser[0].nickname})}
                            </div>
                            <div className="headerBtn">
                                {errorLoad && <button className="finishBtn refresh" onClick={this.handoverRefresh}>
                                    {React.language('handover.re')}
                                </button>}
                                {(finishLoad || errorLoad) && <button className="finishBtn" onClick={this.handoverFinish}>
                                    {React.language('done')}
                                </button>}
                            </div>
                        </div>
                        <div className="load-body">
                            {
                                TodoList.length > 0 && <div className="TodoList loadList">
                                    {
                                        <div className="panel-item">
                                            <div className="item-info" onClick={this.switchLoadItem("todo")}>
                                                <div className="app-name">
                                                    {
                                                        menu[1].text
                                                    }
                                                </div>
                                                <div className="item-icon">
                                                    <i className={todoLoadShow ? "icon-folder-open" : "icon-folder-close"}/>
                                                </div>
                                            </div>
                                            {todoLoadShow &&
                                                <div className="item-form">
                                                    {
                                                        TodoList.map((val, key2) => {
                                                            return <div
                                                                className="handover-form-item"
                                                                onClick={this.getTodoCount(val, key2)}>
                                                                <div className="form-name">
                                                                    {
                                                                        val.name
                                                                    }
                                                                </div>
                                                                <div className="form-description">
                                                                    {React.language('todo.data.tip1')}
                                                                </div>
                                                                <div className="detail-btn-wrapper">
                                                                    {val.showLoad && <div className="spin-body">
                                                                        <div className="x-spin mask-none">
                                                                            <div className="spin-content">
                                                                                <div className="spin-indicator rotate"/>
                                                                            </div>
                                                                        </div>
                                                                    </div>}
                                                                    {
                                                                        val.loadFinish && <div className="load-tip">
                                                                            {
                                                                                val.data.failure === 0 && <span className="successTip">{React.language('handover.finish',{success:val.data.success})}</span>
                                                                            }
                                                                            {
                                                                                val.data.failure !== 0 && <span className="successTip">{React.language('handover.finish',{success:val.data.success})}、</span>
                                                                            }
                                                                            {
                                                                                val.data.failure !== 0 && <span className="errorTip">{React.language('handover.forward',{fail:val.data.failure})}</span>
                                                                            }
                                                                            {
                                                                                val.loadError && <span className="errorTip">{React.language('fail')}</span>
                                                                            }
                                                                        </div>
                                                                    }
                                                                    {
                                                                        val.loadError && <div className="load-tip">
                                                                            <span className="errorTip">{React.language('fail')}</span>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            {
                                CreatorList.length > 0 && <div className="CreatorList loadList">
                                    {
                                        <div className="panel-item">
                                            <div className="item-info" onClick={this.switchLoadItem("creator")}>
                                                <div className="app-name">
                                                    {
                                                        React.language('creator.data')
                                                    }
                                                </div>
                                                <div className="item-icon">
                                                    <i className={creatorLoadShow ? "icon-folder-open" : "icon-folder-close"}/>
                                                </div>
                                            </div>
                                            {creatorLoadShow &&
                                                <div className="item-form">
                                                    {
                                                        CreatorList.map((val, key2) => {
                                                            return <div
                                                                className="handover-form-item">
                                                                <div className="form-name">
                                                                    {
                                                                        val.name
                                                                    }
                                                                </div>
                                                                <div className="detail-btn-wrapper">
                                                                    {val.showLoad && <div className="spin-body">
                                                                        <div className="x-spin mask-none">
                                                                            <div className="spin-content">
                                                                                <div className="spin-indicator rotate"/>
                                                                            </div>
                                                                        </div>
                                                                    </div>}
                                                                    {
                                                                        val.loadFinish && <div className="load-tip">
                                                                            {
                                                                                val.data.failure === 0 && <span className="successTip">{React.language('handover.finish',{success:val.data.success})}</span>
                                                                            }
                                                                            {
                                                                                val.data.failure !== 0 && <span className="successTip">{React.language('handover.finish',{success:val.data.success})}、</span>
                                                                            }
                                                                            {
                                                                                val.data.failure !== 0 && <span className="errorTip">{React.language('handover.forward',{fail:val.data.failure})}</span>
                                                                            }
                                                                            {
                                                                                val.loadError && <span className="errorTip">{React.language('fail')}</span>
                                                                            }
                                                                        </div>
                                                                    }
                                                                    {
                                                                        val.loadError && <div className="load-tip">
                                                                            <span className="errorTip">{React.language('fail')}</span>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            {
                                FlowCreatorList.length > 0 && <div className="CreatorList loadList">
                                    {
                                        <div className="panel-item">
                                            <div className="item-info" onClick={this.switchLoadItem("flow_creator")}>
                                                <div className="app-name">
                                                    {
                                                        React.language('creator.data')
                                                    }
                                                </div>
                                                <div className="item-icon">
                                                    <i className={flowCreatorLoadShow ? "icon-folder-open" : "icon-folder-close"}/>
                                                </div>
                                            </div>
                                            {flowCreatorLoadShow &&
                                                <div className="item-form">
                                                    {
                                                        FlowCreatorList.map((val, key2) => {
                                                            return <div
                                                                className="handover-form-item">
                                                                <div className="form-name">
                                                                    {
                                                                        val.name
                                                                    }
                                                                </div>
                                                                <div className="detail-btn-wrapper">
                                                                    {val.showLoad && <div className="spin-body">
                                                                        <div className="x-spin mask-none">
                                                                            <div className="spin-content">
                                                                                <div className="spin-indicator rotate"/>
                                                                            </div>
                                                                        </div>
                                                                    </div>}
                                                                    {
                                                                        val.loadFinish && <div className="load-tip">
                                                                            {
                                                                                val.data.failure === 0 && <span className="successTip">{React.language('handover.finish',{success:val.data.success})}</span>
                                                                            }
                                                                            {
                                                                                val.data.failure !== 0 && <span className="successTip">{React.language('handover.finish',{success:val.data.success})}、</span>
                                                                            }
                                                                            {
                                                                                val.data.failure !== 0 && <span className="errorTip">{React.language('handover.forward',{fail:val.data.failure})}</span>
                                                                            }
                                                                            {
                                                                                val.loadError && <span className="errorTip">{React.language('fail')}</span>
                                                                            }
                                                                        </div>
                                                                    }
                                                                    {
                                                                        val.loadError && <div className="load-tip">
                                                                            <span className="errorTip">{React.language('fail')}</span>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            {
                                FlowsList.length > 0 && <div className="FlowsList loadList">
                                    {
                                        <div className="panel-item">
                                            <div className="item-info" onClick={this.switchLoadItem("flow")}>
                                                <div className="app-name">
                                                    {
                                                        menu[2].text
                                                    }
                                                </div>
                                                <div className="item-icon">
                                                    <i className={flowLoadShow ? "icon-folder-open" : "icon-folder-close"}/>
                                                </div>
                                            </div>
                                            {flowLoadShow &&
                                                <div className="item-form">
                                                    {
                                                        FlowsList.map((val, key2) => {
                                                            return <div
                                                                className="handover-form-item"
                                                                onClick={this.getTodoCount(val, key2)}>
                                                                <div className="form-name">
                                                                    {
                                                                        val.name
                                                                    }
                                                                </div>
                                                                <div className="form-description">

                                                                </div>
                                                                <div className="detail-btn-wrapper">
                                                                    {val.showLoad && <div className="spin-body">
                                                                        <div className="x-spin mask-none">
                                                                            <div className="spin-content">
                                                                                <div className="spin-indicator rotate"/>
                                                                            </div>
                                                                        </div>
                                                                    </div>}
                                                                    {
                                                                        val.loadFinish && <i className="icon-bsy-finish" />
                                                                    }
                                                                    {
                                                                        val.loadError && <i className="icon-error" />
                                                                    }
                                                                </div>
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            {
                                EntryList.length > 0 && <div className="EntryList loadList">
                                    {
                                        <div className="panel-item">
                                            <div className="item-info" onClick={this.switchLoadItem("entry")}>
                                                <div className="app-name">
                                                    {
                                                        menu[3].text
                                                    }
                                                </div>
                                                <div className="item-icon">
                                                    <i className={formLoadShow ? "icon-folder-open" : "icon-folder-close"}/>
                                                </div>
                                            </div>
                                            {formLoadShow &&
                                                <div className="item-form">
                                                    {
                                                        EntryList.map((val, key2) => {
                                                            return <div
                                                                className="handover-form-item"
                                                                onClick={this.getTodoCount(val, key2)}>
                                                                <div className="form-name">
                                                                    {
                                                                        val.name
                                                                    }
                                                                </div>
                                                                <div className="form-description">
                                                                    {React.language(val.type === 'auth_group' ? 'handover.auth.group' : val.type === 'notify' ? 'handover.notify' : val.type === 'datahelper' ? 'handover.datahelper' : val.type === 'dash_auth' ? 'handover.dash.auth' : '')}
                                                                </div>
                                                                <div className="detail-btn-wrapper">
                                                                    {val.showLoad && <div className="spin-body">
                                                                        <div className="x-spin mask-none">
                                                                            <div className="spin-content">
                                                                                <div className="spin-indicator rotate"/>
                                                                            </div>
                                                                        </div>
                                                                    </div>}
                                                                    {
                                                                        val.loadFinish && <i className="icon-bsy-finish" />
                                                                    }
                                                                    {
                                                                        val.loadError && <i className="icon-error" />
                                                                    }
                                                                </div>
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            {
                                ContactList.length > 0 && <div className="ContactList loadList">
                                    {
                                        <div className="panel-item">
                                            <div className="item-info" onClick={this.switchLoadItem("contact")}>
                                                <div className="app-name">
                                                    {
                                                        menu[4].text
                                                    }
                                                </div>
                                                <div className="item-icon">
                                                    <i className={roleLoadShow ? "icon-folder-open" : "icon-folder-close"}/>
                                                </div>
                                            </div>
                                            {roleLoadShow &&
                                                <div className="item-form">
                                                    {
                                                        ContactList.map((val, key2) => {
                                                            return <div
                                                                className="handover-form-item"
                                                                onClick={this.getTodoCount(val, key2)}>
                                                                <div className="form-name">
                                                                    {
                                                                        val.name
                                                                    }
                                                                </div>
                                                                <div className="form-description">

                                                                </div>
                                                                <div className="detail-btn-wrapper">
                                                                    {val.showLoad && <div className="spin-body">
                                                                        <div className="x-spin mask-none">
                                                                            <div className="spin-content">
                                                                                <div className="spin-indicator rotate"/>
                                                                            </div>
                                                                        </div>
                                                                    </div>}
                                                                    {
                                                                        val.loadFinish && <i className="icon-bsy-finish" />
                                                                    }
                                                                    {
                                                                        val.loadError && <i className="icon-error" />
                                                                    }
                                                                </div>
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>}
                </div>
            </div>
        )
    }
}

export default AlertList